import React from 'react';
import { BaasicDropdown, BaasicInput } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import _ from 'lodash';

const PalletizeFulfillmentOrderTemplate = ({
	store: {
		palletizingForm,
		onKeyUp,
		setInputs,
		palletFindNotification,
		togglePallet,
		scanPackageNotification,
		undoNotification,
		onUndo,
		lastAction,
		onPrintLabel,
		label,
		isSeller,
		isSuperAdminOrganization,
		warehouseDropdownStore,
		palletDropdownStore,
		deletePalletOptionOverride,
		isSmartshipWarehouseAdministrator,
		isWarehouse
	},
	t,
}) => {
	return (
		<section>
			<form className="ReactModal__form" onSubmit={palletizingForm.onSubmit}>
				<div className="ReactModal__body">
					<div className="row">
						{(isSeller || isSuperAdminOrganization || isSmartshipWarehouseAdministrator) && (
							<div className="col col-sml-12 col-med-6">
								<BaasicDropdown
									dropdownStore={warehouseDropdownStore}
									isClearable={true}
									className="spc--bottom--sml flex--grow--1"
									autoFocus
								/>
							</div>
						)}
						<div className="col col-sml-12 col-med-6">
							<div className="inputgroup spc--bottom--sml">
								<div className="inputgroup--main">
									<BaasicDropdown
										dropdownStore={palletDropdownStore}
										isDisabled={(!isWarehouse) && !_.get(warehouseDropdownStore, 'value')}
										optionOverride={deletePalletOptionOverride}
									/>
								</div>
								<div className="inputgroup--aside align--v--bottom">
									<button
										className="btn btn--med btn--primary spc--left--sml"
										disabled={!isWarehouse && !_.get(warehouseDropdownStore, 'value')}
										onClick={togglePallet}
										type="button"
									>
										{t('FULFILLMENTORDER.PALLETIZINGMODE.NEWPALLET')}
									</button>
								</div>
							</div>
							{palletizingForm.error && !palletFindNotification && (
								<p className="padd--top--tny type--color--warning spc--bottom--sml">
									{translate(palletizingForm.error)}
								</p>
							)}
							{palletFindNotification && (
								<p
									className={
										palletFindNotification.includes('NOTFOUND')
											? 'type--color--warning spc--bottom--sml'
											: 'type--color--success spc--bottom--sml'
									}
								>
									{t(palletFindNotification)}
								</p>
							)}
						</div>
					</div>
					<div>
						<BaasicInput
							field={palletizingForm.$('trackingNumber')}
							onKeyUp={onKeyUp}
							disabled={!palletizingForm.$('palletId').value}
							reference={setInputs}
							className="spc--bottom--sml"
						/>
						{scanPackageNotification && (
							<p
								className={
									scanPackageNotification.includes('SUCCESS')
										? 'type--color--success spc--bottom--sml'
										: 'type--color--warning spc--bottom--sml'
								}
							>
								{t(scanPackageNotification)}
							</p>
						)}
						{undoNotification && <div className="type--color--success spc--bottom--sml">{t(undoNotification)}</div>}
					</div>
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--secondary spc--right--sml spc--bottom--sml"
						type="button"
						onClick={onUndo}
						disabled={!lastAction}
					>
						{t('UNDO')}
					</button>
					<button
						className="btn btn--med btn--secondary spc--bottom--sml"
						type="button"
						onClick={onPrintLabel}
						disabled={!palletizingForm.$('palletId').value}
					>
						<span className="fa fa-print spc--right--tny"></span>
						{t('PRINTLABEL')}
					</button>
				</div>
			</form>
			<iframe
				id="pdf-print-modal-pallet"
				name="pdf-print-modal-pallet"
				src={label}
				style={{ display: 'none' }}
			></iframe>
		</section>
	);
};

export default defaultTemplate(PalletizeFulfillmentOrderTemplate);
